export const UserType = {
  Admin: 'Admin',
  Manager: 'Manager',
  User: 'User',
} as const;
export type UserType = (typeof UserType)[keyof typeof UserType];
